export { getProfilePictureWithTimestamp } from './imageUtils';
export { getErrorMessage } from './servicesUtils';
export { getInitials } from './stringUtils';
export {
    getCookie,
    getChunkedCookie,
    getToken,
    getRefreshToken,
    getExchangeCodeTokenFromCookie,
    getTokenExpiration,
    isTokenExpired,
} from './cookieUtils';
export {
    // Detecção de tipo de mídia por URL
    isValidUrl,
    isUploadUrl,
    getFileNameFromUrl,
    getExtensionFromUrl,
    isAudioFileName,
    detectMediaTypeFromExtension,
    detectMediaTypeFromUrl,
    isMediaUrl,
    // Formatação de data/hora
    formatMessageTime,
    formatDateHeader,
    isSameDay,
    groupMessagesByDate,
    // Mapeamento de mensagens
    getMessageType,
    mapToMessageProps,
    // Conversão de tipos de anexo
    convertMimeToAttachmentType,
    convertToAttachmentExtension,
    getFileExtension,
    // Auxiliares de mensagem
    isMediaMessage,
    hasAttachment,
    generateMessageId,
    isSameSender,
    shouldShowUserName,
} from './chatUtils';
